/**
 * This page is cloned from the invoices page so it might
 * have similar naming conventions to the invoices page
 *
 */

import { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import { invokeUserRefetch } from "../../../store/slices/storeSlice";
import Animation from "../../Animation";
import useCheckIsMobile from "../../lesson/lessonRefactor/utils/useCheckIsMobile";
import CheckCode from "./CheckCode";
import CreateCode from "./CreateCode";
import EditCode from "./EditCode";

const CodeManagement = () => {
  const [error, setError] = useState(null);
  const { isMobile } = useCheckIsMobile();

  useEffect(() => {
    dispatch(invokeUserRefetch());
  }, []);

  const { userProfileData } = useAppSelector((state) => state.store);
  const dispatch = useAppDispatch();

  return (
    <Animation>
      <div className="overflow-x-auto space-y-6">
        <h3 className="bg-primary p-3 text-white rounded-lg shadow font-bold">
          إدارة الأكواد
        </h3>

        <div className={`${isMobile ? "" : "flex flex-wrap gap-2"}`}>
          <div
            className="rounded-lg font-bold border border-blue-400 bg-blue-100 text-blue-800 px-4 py-2 shadow-sm"
            role="alert"
          >
            رصيد المحفظة : {userProfileData?.wallet_credit ?? 0} جنيه
          </div>
          <div
            className="rounded-lg font-bold border border-yellow-500 bg-yellow-100 text-yellow-800 px-4 py-2 shadow-sm"
            role="alert"
          >
            رصيد الأكواد المجانية : {userProfileData?.free_codes_credit ?? 0}
          </div>
        </div>

        <CreateCode />

        <EditCode />

        <CheckCode />

        {error && (
          <h2 className="text-red-600 font-bold text-lg mt-4">
            يجب تسجيل الدخول اولا
          </h2>
        )}
      </div>
    </Animation>
  );
};

export default CodeManagement;
